import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoriesService } from 'src/app/services/categori.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-cat-details',
  templateUrl: './cat-details.component.html',
  styleUrls: ['./cat-details.component.css'],
})
export class CatDetailsComponent implements OnInit {
  cat_id: any;
  formStatus = false;
  showProduct = false;
  cat_obj = {
    name: '',
    image: '',
    products: [],
  };
  product_arr: any = [];
  cat_name = '';
  image_file: any = [];
  productForm: FormGroup | any;
  showUpload = false;
  product_id: any;
  constructor(
    private route: ActivatedRoute,
    private routing: Router,
    private _sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private rest: CategoriesService
  ) {}

  ngOnInit() {
    this.rest.showSpinner();
    this.productForm = this.formBuilder.group({
      name: ['', Validators.required],
      name_ar: [''],
      price: ['', Validators.required],
      description: ['', Validators.required],
      description_ar: [''],
      quantity: ['', Validators.required],
    });
    this.cat_id = this.route.snapshot.paramMap.get('id');
    this.getData();
  }

  getData() {
    this.image_file = [];
    this.rest.cat_full_details(this.cat_id).subscribe((res: any) => {
      // if(res.image != null){
      //   res.image.image = this._sanitizer.bypassSecurityTrustUrl(`data:image/png;base64,`+ res.image.image);
      //   this.cat_obj.image = res.image.image
      // }else {
      //   this.cat_obj.image = "assets/images/rk.jpeg"
      // }
      this.cat_obj.name = res.name;
      this.cat_name = this.cat_obj.name;

      res.products.forEach((element: any) => {
        if (element.images.length != 0) {
          element.images[0].image_url = `${environment.apiUrl}/images/?id=${element.images[0].image_url}`;
        } else {
          element.images[0] = {
            image_url: 'assets/images/rk.jpeg',
          };
        }
      });

      this.product_arr = res.products;

      if (this.product_arr.length != 0) {
        this.showProduct = true;
      } else {
        this.showProduct = false;
      }
      this.rest.hideSpinner();
    });
  }

  resetProductModal() {
    this.showUpload = false;
    this.formStatus = false;
    this.image_file = [];
    this.productForm.reset();
  }

  addProduct() {
    if (this.productForm.valid) {
      this.formStatus = false;
      const v = this.productForm.value;
      const obj: any = {
        name: v.name,
        name_ar: v.name_ar || null,
        price: parseFloat(v.price),
        description: v.description,
        description_ar: v.description_ar || null,
        quantity: parseInt(v.quantity, 10),
        category_id: parseInt(this.cat_id, 10),
      };
      this.rest.addProduct(obj).subscribe(
        (res: any) => {
          this.product_id = res;
          this.showUpload = true;
          this.productForm.reset();
        },
        (err: any) => {
          this.rest.errorToaster(err?.error?.message || 'toast.error_generic');
        }
      );
    } else {
      this.formStatus = true;
    }
  }
  image_file_cat: any;
  uploadFileCat(e: any) {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      this.image_file_cat = e.target.files[0];
    }
  }
  addCategoryImage() {
    if (this.image_file_cat != undefined) {
      this.rest
        .upload_cat_image(this.cat_id, this.image_file_cat)
        .then((response: any) => response.text())
        .then((result: any) => {
          this.rest.successToast('toast.category_image_updated');
          this.getData();
        })
        .catch((error: any) => {
          this.rest.errorToaster('toast.error_generic');
        });
    } else {
      this.getData();
    }
  }

  uploadFile(e: any, type: any) {
    let dummy: any = e.target.files;
    for (let i = 0; i < dummy.length; i++) {
      this.image_file.push({
        name: type + [i],
        value: dummy[i],
      });
    }

  }

  addProductImage() {
    if (this.image_file.length === 0) {
      this.getData();
      this.rest.successToast('toast.product_added');
      this.showUpload = false;
      return;
    }
    this.rest.showSpinner();
    this.rest
      .upload_product_image(this.product_id, this.image_file)
      .then((response: any) => response.text())
      .then((result: any) => {
        this.image_file = [];
        this.getData();
        this.rest.successToast('toast.product_added');
        this.rest.hideSpinner();
        this.showUpload = false;
      })
      .catch((error: any) => {
        this.rest.errorToaster('toast.error_reload');
        this.rest.hideSpinner();
      });
  }

  editCat() {
    this.rest.showSpinner();
    this.cat_id = +this.cat_id;
    let obj = {
      id: this.cat_id,
      name: this.cat_name,
    };
    this.rest.editCat(obj).subscribe(
      (res: any) => {
        this.rest.hideSpinner();
        this.getData();
        this.rest.successToast('toast.category_name_updated');
      },
      (err: any) => {
        this.rest.errorToaster('toast.error_generic');
        this.rest.hideSpinner();
      }
    );
    this.addCategoryImage();
  }

  deleteCategory() {
    this.rest.showSpinner();
    this.rest
      .deleteCategory(this.cat_id)
      .then((response) => response.text())
      .then((result) => {
        this.rest.hideSpinner();
        this.routing.navigate(['main/categories']);
      })
      .catch((error) => {
        this.rest.errorToaster('toast.error_generic');
        this.rest.hideSpinner();
      });
  }

  productDetails(id: any) {
    this.routing.navigate(['main/product_details', id]);
  }

  search(data: any) {
    this.rest
      .searchProd(data.target.value, this.cat_id)
      .subscribe((res: any) => {
        res.forEach((element: any) => {
          element.images = [
            {
              image_url: `${environment.apiUrl}/images/?id=${element.image[0]}`,
            },
          ];
        });

        this.product_arr = res;

        if (this.product_arr.length != 0) {
          this.showProduct = true;
        } else {
          this.showProduct = false;
        }
      });
  }
}
